import React from "react";

function ReviewActivityLogIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2867_5181)">
        <g clipPath="url(#clip1_2867_5181)">
          <path
            d="M8 1C9.58225 1 11.129 1.46919 12.4446 2.34824C13.7602 3.22729 14.7855 4.47672 15.391 5.93853C15.9965 7.40034 16.155 9.00887 15.8463 10.5607C15.5376 12.1126 14.7757 13.538 13.6569 14.6569C12.538 15.7757 11.1126 16.5376 9.56072 16.8463C8.00887 17.155 6.40034 16.9965 4.93853 16.391C3.47672 15.7855 2.22729 14.7602 1.34824 13.4446C0.469192 12.129 0 10.5822 0 9C0 8.82319 0.0702379 8.65362 0.195262 8.52859C0.320286 8.40357 0.489856 8.33333 0.666667 8.33333C0.843478 8.33333 1.01305 8.40357 1.13807 8.52859C1.2631 8.65362 1.33333 8.82319 1.33333 9C1.33333 10.3185 1.72433 11.6075 2.45687 12.7038C3.18941 13.8001 4.2306 14.6546 5.44878 15.1592C6.66695 15.6638 8.00739 15.7958 9.3006 15.5386C10.5938 15.2813 11.7817 14.6464 12.714 13.714C13.6464 12.7817 14.2813 11.5938 14.5386 10.3006C14.7958 9.00739 14.6638 7.66695 14.1592 6.44878C13.6546 5.2306 12.8001 4.18941 11.7038 3.45687C10.6075 2.72433 9.31854 2.33333 8 2.33333C6.06933 2.33333 4.40667 3.09333 2.84667 5H4C4.15603 4.99995 4.30714 5.05463 4.42701 5.15452C4.54688 5.25441 4.62791 5.39318 4.656 5.54667L4.66667 5.66667C4.66672 5.8227 4.61204 5.97381 4.51215 6.09368C4.41226 6.21355 4.27349 6.29458 4.12 6.32267L4 6.33333H1.33333C1.1773 6.33338 1.02619 6.2787 0.906321 6.17881C0.786453 6.07892 0.705419 5.94015 0.677333 5.78667L0.666667 5.66667V3C0.66636 2.83341 0.728438 2.67273 0.840678 2.54962C0.952917 2.42651 1.10718 2.34989 1.2731 2.33483C1.43901 2.31978 1.60455 2.36739 1.73711 2.46829C1.86967 2.56919 1.95965 2.71607 1.98933 2.88L2 3V3.93333C3.77067 1.876 5.75067 1 8 1ZM7.33333 5C7.48937 4.99995 7.64048 5.05463 7.76034 5.15452C7.88021 5.25441 7.96125 5.39318 7.98933 5.54667L8 5.66667V9.39067L10.472 11.8613C10.5822 11.9718 10.6502 12.1175 10.6641 12.2729C10.678 12.4283 10.6369 12.5837 10.548 12.712L10.472 12.8053C10.3615 12.9156 10.2159 12.9835 10.0604 12.9974C9.90499 13.0113 9.7496 12.9702 9.62133 12.8813L9.528 12.8053L6.86133 10.1387C6.76201 10.0392 6.69667 9.91085 6.67467 9.772L6.66667 9.66667V5.66667C6.66667 5.48986 6.7369 5.32029 6.86193 5.19526C6.98695 5.07024 7.15652 5 7.33333 5Z"
            fill="#424242"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2867_5181">
          <rect width="16" height="17" fill="white" />
        </clipPath>
        <clipPath id="clip1_2867_5181">
          <rect
            width="18"
            height="16"
            fill="white"
            transform="translate(-1 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ReviewActivityLogIcon;
